export const ACCOUNT_EXTENSION_KEY_CMVCC_SEAT = "cmvccSeat";